(function () {
	'use strict';

	if (window.__pdpNotifyMeLoaded) return;
	window.__pdpNotifyMeLoaded = true;

	function getVariantId(btn) {
		if (btn.dataset.variantId) return parseInt(btn.dataset.variantId, 10);
		var form = btn.closest('form');
		var input = form && form.querySelector('[name="id"]');
		return input ? parseInt(input.value, 10) : null;
	}

	function openRestockModal(btn) {
		if (!window._RestockRocket || typeof window._RestockRocket.openModal !== 'function') return false;
		var productData = window.__pdpNotifyProduct;
		if (!productData) return false;
		productData.available = false;
		if (productData.variants && productData.variants[0]) {
			productData.variants[0].available = false;
		}
		window._RestockRocket.openModal(productData, getVariantId(btn));
		return true;
	}

	document.addEventListener('click', function (evt) {
		var btn = evt.target.closest('[data-pdp-notify-me]');
		if (!btn) return;
		evt.preventDefault();

		if (openRestockModal(btn)) return;
		var elapsed = 0;
		var timer = setInterval(function () {
			elapsed += 200;
			if (openRestockModal(btn) || elapsed >= 5000) clearInterval(timer);
		}, 200);
	});
})();
